<!--
 * @Author: shp
 * @Date: 2024-12-04 11:28:19
 * @LastEditTime: 2025-01-10 15:38:20
 * @FilePath: /vueSaas/saas/src/views/money/money.vue
 * @Description: 
-->
<template>
    <div class="k-page-content">
      <el-tabs v-model="activeName" class="box-eltab">
        <el-tab-pane label="账户充值" name="first">
          <div class="k-page-common">
            <div class="k-common-header">
              <div class="k-filter-option k-filter-input">
                <el-input
                  placeholder="请输入充值账户ID或名称"
                  v-model="searchForm.name"
                  :size="size"
                  clearable
                  @blur="doSearch"
                ></el-input>
              </div>
              <div class="k-filter-option k-filter-input">
                <!-- Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. 
                Instead, use a data or computed property based on the prop's value. Prop being mutated: "placement"-->
                <!-- 添加align属性预防以上报错 -->
                <el-date-picker
                  align="center"
                  :size="size"
                  v-model="searchForm.time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @blur="doSearch"
                ></el-date-picker>
              </div>
              <el-button type="primary" :size="size" @click="handleSearch(1)">搜索</el-button>
              <el-button type="primary" :size="size" @click="doSearch">重置</el-button>
            </div>
            <div class="k-common-con">
              <div class="k-table-wrapper">
                <div class="k-table-toolbar">
                  <div>
                    <el-button type="primary" :size="size" @click="accountMoney">账户充值</el-button>
                  </div>
                </div>
                <div class="k-table-con">
                  <el-table :data="tableData.data" border style="width: 100%">
                    <el-table-column prop="id" fixed label="任务ID" min-width="100"></el-table-column>
                    <el-table-column prop="task_type" label="任务类型" min-width="100"></el-table-column>
                    <el-table-column label="执行状态" min-width="100">
                      <template slot-scope="scope">
                          <el-tag v-if="scope.row.status == '0'" type="info" :size="size">草稿</el-tag>
                          <el-tag v-if="scope.row.status == '1'" :size="size">等待中</el-tag>
                          <el-tag v-if="scope.row.status == '2'" type="warning" :size="size">进行中</el-tag>
                          <el-tag v-if="scope.row.status == '3'" :size="size" type="success">成 功</el-tag>
                          <el-tag v-if="scope.row.status == '4'" type="danger" :size="size">失 败</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="错误数" min-width="50">
                      <template slot-scope="scope">
                        <span v-if="scope.row.status=='3' || scope.row.status=='4'" style="font-weight: bold;color:red">{{scope.row.total-scope.row.progress}}</span>
                        <span v-else style="font-weight: bold;color:red">0</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="执行进度" min-width="150">
                      <template slot-scope="scope">
                        <span style="font-weight: bold">{{scope.row.progress}}/{{scope.row.total}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="uid_name" label="创建人" min-width="100"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" min-width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="100">
                      <template slot-scope="scope">
                        <el-button type="text" :size="size" @click="openLogDialog(scope.row.id)">交易日志</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    ref="pagination"
                    @current-change="handleCurrentChange"
                    :current-page="tableData.page | number"
                    :page-size="tableData.pagesize | number"
                    layout="total, prev, pager, next, jumper"
                    :total="tableData.total | number"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

        <!-- 添加充值弹窗 -->
        <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="70%" @closed="clearnForm">
            <el-form
                :model="addForm"
                ref="addForm"
                :size="size"
                label-width="110px"
                label-position="top"
            >
                <div class="drawer-header">
                    <div class="header-title">
                        <span>账户充值</span>
                        <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="备款账户:" prop="from_account_id" :rules="{ required: true, message: '请选择打款的广告主', trigger: 'change' }">
                        <el-select
                            style="width: 100%"
                            v-model="addForm.from_account_id"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getDKAccountSelect"
                            collapse-tags
                            placeholder="可输入账户名称或账户ID搜索">
                            <el-option
                            v-for="item in options.DKdata"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="充值账户:" prop="account_ids_txt" :rules="{ required: true, message: '请填写充值的广告主ID', trigger: ['change','blur'] }">
                        <p>
                            <el-input
                            type="textarea"
                            :rows="10"
                            placeholder='批量输入广告主ID,英文","(逗号)隔开,例:3243432,78686787...'
                            v-model="addForm.account_ids_txt">
                            </el-input>
                        </p>
                        <p style="margin-top: 10px;">
                            <el-button style="margin-left:10px" :size="size" type="primary" @click="addPSearch">批量生成</el-button>
                            <el-button type="primary" @click="openUpload">模版导入<i class="el-icon-upload el-icon--right"></i></el-button>
                        </p>
                    </el-form-item>
                    <el-form-item v-if="addForm.info_arr.length > 0">
                        <el-divider></el-divider>
                        <el-descriptions class="margin-top" :column="4" :size="size" border :title="'充值明细  (总计：' + sumCost()+'元)'">
                            <template slot="extra">
                                <el-button type="primary" :size="size" @click="dialogFormVisible = true">批量设置</el-button>
                            </template>
                            <template v-for="(domain, index) in addForm.info_arr">
                                <el-descriptions-item >
                                    <template slot="label">序号</template>
                                    {{ index+1 }}
                                </el-descriptions-item>
                                <el-descriptions-item >
                                    <template slot="label">广告主ID</template>
                                    {{ domain.account_id }}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">类型</template>
                                    <el-select v-model="domain.transfer_type" placeholder="请选择充值类型">
                                        <el-option label="现金充值" :value="1"></el-option>
                                        <el-option label="信用账户充值" :value="2"></el-option>
                                    </el-select>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">充值</template>
									<div style="position: relative; top:8px;">
                                    <el-form-item :prop="'info_arr.' + index + '.cost'" :rules="[{
                                    required: true, message: '充值金额不能为空', trigger: 'blur'
                                    },{
                                        validator: function(rule, value, callback){
                                            const regex = /^\d+(\.\d{1,2})?$/;
                                            if(!regex.test(value)){
                                                callback('充值金额不合法')
                                            }else if(value <= 0){
                                                callback('充值金额不能为0')
                                            }else{
                                                callback()
                                            }
                                        }, trigger: 'blur' 
                                    }]">
                                        <el-input v-model="domain.cost">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    </div>
                                </el-descriptions-item>
                            </template>
                        </el-descriptions>
                    </el-form-item>
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" :size="size" @click="addMoneyTrans('addForm')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
                    <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
                </div>
                </el-form>

        </el-drawer>
        <!-- 批量设置 -->
        <el-dialog title="批量设置" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="form" ref="form" label-width="150px" :size="size">
                <el-form-item label="批量类别" prop="type" :rules="{ required: true, message: '请选择类别', trigger: 'change' }">
                    <el-select v-model="form.type" placeholder="请选择类别" @change="form.value=''">
                        <el-option label="充值类型" value="1"></el-option>
                        <el-option label="充值金额" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设置充值金额" v-if="form.type=='2'" prop="value" :rules="[{ required: true, message: '请输入充值金额', trigger: 'blur'},{ validator: function(rule, value, callback){
                                        const regex = /^\d+(\.\d{1,2})?$/;
                                        if(!regex.test(value)){
                                            callback('充值金额不合法')
                                        }else{
                                            callback()
                                        }
                                    }, trigger: 'blur' }]">
                    <el-input v-model="form.value">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="设置充值类型" v-if="form.type=='1'" prop="value" :rules="{ required: true, message: '请选择类型', trigger: 'change' }">
                    <el-select v-model="form.value" placeholder="请选择充值类别">
                        <el-option label="现金充值" value="1"></el-option>
                        <el-option label="信用账户充值" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" @click="dialogFormVisible = false">取 消</el-button>
                <el-button :size="size" type="primary" @click="setInfo('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 交易日志 -->
        <el-dialog title="交易日志" :visible.sync="dialogLogVisible">
            <el-table
                border
                max-height="300"
                :data="gridData"
                style="width: 100%"
                :row-class-name="tableRowClassName">
                <el-table-column label="序号" width="50">
                    <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column
                prop="from_account_id_txt"
                label="From 广告主"
                min-width="200">
                </el-table-column>
                <el-table-column
                prop="account_id_txt"
                label="To 广告主"
                min-width="200">
                </el-table-column>
                <el-table-column
                prop="trade_no"
                label="交易号"
                min-width="200">
                </el-table-column>
                <el-table-column
                prop="transfer_type_txt"
                label="充值类型"
                min-width="120">
                <template slot-scope="scope">
                    <el-tag type="info" :size="size" effect="dark">{{ scope.row.transfer_type_txt }}</el-tag>
                </template>
                </el-table-column>
                <el-table-column
                prop="cost"
                label="金额(元)"
                min-width="100">
                </el-table-column>
                <el-table-column
                prop="trade_status_txt"
                label="交易反馈"
                min-width="200">
                </el-table-column>
                <el-table-column
                prop="create_time"
                label="创建时间"
                min-width="180">
                </el-table-column>
            </el-table>

        </el-dialog>
        <!-- 导入excel -->
        <el-dialog
        title="上传打款明细"
        :visible.sync="uploadFormVisiable"
        v-loading="loading"
        width="40%">
            <el-form :model="uploadForm" ref="uploadForm" :size="size" label-width="130px">
                <div>
                    <el-form-item label="上传文件:" prop="excel_file">
                        <el-upload
                        drag
                        ref="upload"
                        accept=".xls,.xlsx"
                        action
                        :http-request="(file)=>{return imggreySuccess(file ,'files')}"
                        :on-remove="(file) => handleRemoveUpload(file, 'files')"
                        :limit='1'
                        :on-exceed="limitMessage"
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br/><span>支持 .xls .xlsx</span></div>
                        <div class="el-upload__tip" slot="tip"><a @click="exportExcelTemplate()" target="_blank" style="color: #409EFF; font-size: 12px; cursor: pointer;">模板下载</a></div>
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addOrder()" :size='size'>提交</el-button>
                <el-button :size='size' @click="uploadFormVisiable = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  <style>
    .el-table .warning-row {
        background: #E6A23C;
    }
    .el-table .success-row {
        background: #f0f9eb;
    }
    .el-table .danger-row {
        background: #F56C6C;
    }
  </style>
<script>
export default {
    data() {
        return {
            sform:{
                account_ids: ''
            },
            size:'mini',
            activeName:'first',
            addFormVisiable:false,
            dialogFormVisible:false,
            dialogLogVisible:false,
            dialogSearchVisible:false,
            uploadFormVisiable:false,
            loading:false,
            addForm:{
                from_account_id:'',
                account_ids_txt:'',
                info_arr:[]
            },
            form:{
                type:'',
                value:''
            },
            searchForm: {
                name: '',
                time: []
            },
            options:{
                DKdata:[],
                data:[]
            },
            uploadForm:{
                files:[]
            },
            gridData:[],
            tableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: []
            }
        }
    },
    mounted: function(){
        // 使用的是发布广告使用的获取账户接口，默认会加上广告页面的媒体ID,当前页面不需要加，暂时解决方案是先去掉mediaID
        localStorage.setItem('mediaId', '')
        this.handleSearch()
    },
    methods: {
        sumCost(){
            var costs_arr = this.addForm.info_arr.map(item => item.cost);
            return costs_arr.reduce((prev,curr) => {
                        return parseFloat(prev)+parseFloat(curr)
                    })
        },
        openUpload(){
            this.uploadFormVisiable = true
        },
        addOrder(){
            const formData = new FormData()
            if(this.uploadForm.files.length > 0){
				this.uploadForm.files.forEach(item => {
				  formData.append('excel_file', item)
				})
			}
            this.$api.post('user/uploadfiels',formData).then(res => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const text = event.target.result;
                    try {
                        const jsonObj = JSON.parse(text);
                        if (jsonObj.code === 0) {
                            this.addForm.info_arr = jsonObj.data.items
                            this.$set(this.addForm,'account_ids_txt',jsonObj.data.ids.join(','))
                            this.uploadFormVisiable = false
                        } else {
                            this.$message.error(jsonObj.msg);
                        }
                    } catch (error) {
                        this.$message.error("解析JSON时出错:"+error);
                    }
                };

                reader.onerror = (error) => {
                    this.$message.error("读取Blob为文本时出错:"+error);
                };
                reader.readAsText(res);
                
            })
        },
        imggreySuccess: function(files, field) {
		    this.uploadForm[field].push(files.file)
		},
        handleRemoveUpload(files, field){
            this.uploadForm[field] = []
        },
        limitMessage: function(files, fileList) {
		  this.$message.error('最多可以上传一个文件，删除后可再次上传')
		},
        exportExcelTemplate(){
			this.$api.get('user/exporttemplate').then(res => {
                // 将Blob转换为URL以便创建一个可下载的链接
                const url = window.URL.createObjectURL(new Blob([res]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '账户打款.xlsx'); // 设置下载文件名
                document.body.appendChild(link);
                link.click(); // 触发点击下载
                document.body.removeChild(link); // 下载后移除元素
                window.URL.revokeObjectURL(url); // 释放URL对象	
			})
        },
        addPSearch(){
            if (this.addForm.account_ids_txt) {
                var new_ids = this.addForm.account_ids_txt.split(',')
                this.changeAccount(new_ids)
            }else{
                this.$message.error('请先填写需要打款的账户')
            }
        },
        piliangSearch(){
            this.dialogSearchVisible = true
        },
        tableRowClassName({row, rowIndex}) {
            if (row.trade_status === 'FAILED') {
                return 'warning-row';
            } else if (row.trade_status === 'EXCEPTION' || row.trade_status === 'IGNORED') {
                return 'danger-row';
            } else if (row.trade_status === 'SUCCESS') {
                return 'success-row';
            }
            return '';
        },
        clearnForm(){
            this.addForm = {
                account_ids:[],
                info_arr:[]
            }
        },
        setInfo(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.form.type=='1'){
                        this.addForm.info_arr.forEach((item,index)=>{
                            this.$set(item, 'transfer_type', this.form.value)
                        })
                    }else if(this.form.type=='2'){
                        this.addForm.info_arr.forEach((item,index)=>{
                            this.$set(item, 'cost', this.form.value)
                        })
                    }
                    this.dialogFormVisible = false
                }
            })
        },
        accountMoney(){
            this.getDKAccountSelect()
            this.addFormVisiable = true
        },
        doSearch: function(event) {
            this.handleSearch()
        },
        reset: function() {
            this.searchForm = {
                name: '',
                time: []
            }
            this.handleSearch(page)
        },
        handleCurrentChange: function(page) {
            this.handleSearch(page)
        },
        openLogDialog(id){
            this.$api.get('money/finance/gettaskloglist', {id:id}).then(res => {
                if (res.code === 0) {
                    this.gridData = res.data
                    this.dialogLogVisible = true
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                   })
                }
            })
        },
        handleSearch(page, prop, order){
            this.loading = true
            var param = {}
            param['time'] = this.searchForm.time ? this.searchForm.time : this.resetSearch.time
            param['page'] = page ? page : 1
            param['prop'] = prop ? prop : 'id'
            param['order'] = order ? order : 'desc'
            this.$api.get('money/finance/tasklist', param).then(res => {
                if (res.code === 0) {
                this.tableData = res.data
                } else {
                var message = '查询应用列表信息失败！'
                if (res.msg) {
                    message = res.msg
                }
                this.$message({
                    showClose: true,
                    message: message,
                    type: 'error'
                })
                }
                this.loading = false
            })
        },
        addMoneyTrans(formName){
            this.loading = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addForm.account_ids = this.addForm.account_ids_txt.split(',')
                    this.$api.post('money/finance/addmoney', this.addForm).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                showClose: true,
                                message: '充值任务成功',
                                type: 'success'
                            })
                            this.handleSearch(1)
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            })
                        }
                        this.addFormVisiable = false
                    })
                }
                this.loading = false
            })
        },
        changeAccount(values){
            // 数据表中已经存在的
            var list = []
            values.forEach((item,index)=>{
                list.push({transfer_type:2, account_id:item, cost:'0'})
            })
            this.$set(this.addForm,'info_arr',list)
        },
        getDKAccountSelect:function(query){
            var query_name = ''
            if(query){
                query_name = query
            }
            this.$api.get('money/finance/predepositaccounts', {query:query_name}, res => {
                if (res.code == '0') {
                    this.$set(this.options,'DKdata',res.data)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
    }
   
}
</script>